
    import { defineComponent } from 'vue';
    import { useUserStore } from './stores/user';
    import { MutationType } from 'pinia';
    import { AxiosError, AxiosResponse } from 'axios';
    import { useProgrammatic } from '@oruga-ui/oruga-next';
    import { useResultsStore } from './stores/citation-search-results';


    export default defineComponent({
        name: 'App',
        components: {

        },
        computed: {
            computedUserId(): string {
                if (this.currentUser != null) {
                    return this.currentUser.UserID;
                }
                return '';
            },

            timeLeft(): number {              
                if (this.results.checkoutTimer != null) {
                    var miliLeft = (new Date(this.results.checkoutTimer).getTime() + 3600000) - new Date().getTime();
                    return miliLeft < 0 ? 0 : miliLeft;
                }
                return 0;
            }
        },
        data() {
            const { oruga } = useProgrammatic();

            function successToast() {
                oruga.notification.open({
                    message: 'Successfully logged out!',
                    rootClass: 'toast-notification',
                    position: 'top',
                    duration: 5000,
                    variant: 'success'
                });
            }

            function inactivityToast() {
                oruga.notification.open({
                    message: 'You have been logged out due to inactivity.',
                    rootClass: 'toast-notification',
                    position: 'top',
                    duration: 5000,
                    variant: 'warning'
                });
            }

            const userStore = useUserStore()

            return {
                userStore,
                results: useResultsStore(),
                successToast,
                inactivityToast,
                isUserLoggedIn: false as boolean,
                currentUser: userStore.user,
                isLogoutPageLoading: false as boolean,
            }
        },
        methods: {
            logout(): void {
                this.isLogoutPageLoading = true;

                this.$axios
                    .get('account/Logout')
                    .then((response: AxiosResponse) => {
                        if (response.status == 200) {
                            // --- Reset the userStore to its initial state. --- //
                            this.userStore.$reset();

                            this.successToast();
                            this.$router.push({ name: 'search' });
                        }
                    })
                    .catch((error: AxiosError) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.isLogoutPageLoading = false;
                    });

            },
            checkSession(): void {
                this.$axios
                    .get('Account/CheckSession')
                    .then((response: AxiosResponse) => {
                        if (response.status == 200) {
                            this.userStore.$patch({
                                user: response.data
                            });
                        }
                    })
                    .catch(() => {
                        this.userStore.$patch({
                            user: null
                        });

                        this.inactivityToast();

                    });
            },
            checkoutTimerEnded(): void {
                this.results.clearResults();
                this.$router.push({ name: 'search' });
            },
        },
        created() {
            var self = this;

            window.setInterval(() => {
                if (self.currentUser != null && Object.keys(self.currentUser).length > 0) {
                    self.checkSession();
                }
            }, 5 * 60000); // 5 * 1000 milsec

            if (this.currentUser != null && Object.keys(this.currentUser).length > 0) {
                this.checkSession();
            }


            // --- Subscribe to the session storage to watch for patch updates to the store. This will then change the state of the menu. --- //
            // --- https://pinia.vuejs.org/core-concepts/state.html#subscribing-to-the-state --- //
            this.userStore.$subscribe((mutation, state) => {
                mutation.type = MutationType.patchObject;
                mutation.storeId = 'user';

                if (state.user != null && Object.keys(state.user).length > 0) {
                    this.currentUser = state.user;
                    this.isUserLoggedIn = true;
                }
                else {
                    this.isUserLoggedIn = false;
                }
            })
        },
        mounted() {

            let googleTranslateInitScript = document.createElement('script');
            googleTranslateInitScript.text = "" +
                "function googleTranslateElementInit(){" +
                "new google.translate.TranslateElement({ pageLanguage: 'en' }, 'google_translate_element');" +
                "};"
            document.head.appendChild(googleTranslateInitScript)

            let googleTranslateScript = document.createElement('script');
            googleTranslateScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit')
            document.head.appendChild(googleTranslateScript)


            document.addEventListener('DOMContentLoaded', () => {

                // Get all "navbar-burger" elements
                const navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

                // Add a click event on each of them
                navbarBurgers.forEach(el => {
                    el.addEventListener('click', () => {

                        // Get the target from the "data-target" attribute
                        const t = el.dataset.target;
                        const target = document.getElementById(t);

                        if (target != null) {
                            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                            el.classList.toggle('is-active');
                            target.classList.toggle('is-active');

                        }

                    });
                });

            });


        },
    });
